
<div class="PlanRouteView">
  <aside class="PlanRouteView__panel">
    <section class="PlanRouteView__section">
      <h1 class="title is-5">
        {{ isEditMode ? 'Edytuj trasę' : 'Zaplanuj trasę' }}
      </h1>

      <b-message
          v-if="loadError"
          type="is-danger"
          size="is-small"
      >
        {{ loadError }}
      </b-message>

      <b-message
          v-if="successMessage"
          type="is-success"
          size="is-small"
      >
        {{ successMessage }}
      </b-message>

      <b-message
          v-if="conflictMessage"
          type="is-warning"
          size="is-small"
      >
        {{ conflictMessage }}
      </b-message>

      <div class="PlanRouteView__stats">
        <span class="tag">
          Widoczne punkty stałe: {{ permanentPoints.length }}
        </span>

        <span class="tag">
          Widoczne zamówienia: {{ orderPoints.length }}
        </span>

        <span class="tag is-light">
          Bez współrzędnych: {{ pointsWithoutCoordinates.length }}
        </span>
      </div>

      <div class="PlanRouteView__loaders">
        <span v-if="isOrdersLoading">
          <i class="mdi">hourglass_empty</i>
          Ładowanie zamówień
        </span>

        <span v-if="isPermanentPointsLoading">
          <i class="mdi">hourglass_empty</i>
          Ładowanie punktów stałych
        </span>

        <span v-if="isUsersLoading">
          <i class="mdi">hourglass_empty</i>
          Ładowanie użytkowników
        </span>

        <span v-if="isRouteEditLoading">
          <i class="mdi">hourglass_empty</i>
          Ładowanie trasy do edycji
        </span>
      </div>
    </section>

    <section class="PlanRouteView__section">
      <selected-route-points
          :points="selectedPoints"
          :conflicts="conflicts"
          @input="selectedPoints = $event"
          @remove="removePoint"
      />

      <button
          type="button"
          class="button is-small is-light PlanRouteView__clear"
          :disabled="!selectedPoints.length || isSaving"
          @click="clearSelectedPoints"
      >
        Wyczyść wybór
      </button>
    </section>

    <section class="PlanRouteView__section">
      <plan-route-form
          v-model="routeForm"
          :users="users"
          :is-saving="isSaving"
          :is-users-loading="isUsersLoading"
          :errors="validationErrors"
          :form-error="formError"
          :is-edit-mode="isEditMode"
          @submit="submitRoute"
      />
    </section>

    <section
        v-if="pointsWithoutCoordinates.length"
        class="PlanRouteView__section"
    >
      <h2 class="title is-6">
        Punkty bez współrzędnych
      </h2>

      <ul class="PlanRouteView__missing">
        <li
            v-for="point in pointsWithoutCoordinates.slice(0, 8)"
            :key="point.key"
        >
          {{ point.name }}

          <small>
            {{ point.address }}
          </small>
        </li>
      </ul>
    </section>

    <Footer/>
  </aside>

  <div class="PlanRouteView__map">
    <RouteMap
        mode="planning"
        :planning-points="visibleMapPoints"
        :selected-point-keys="selectedPointKeys"
        :planning-route-color="routeForm.color"
        @toggle-point="togglePoint"
    />
  </div>
</div>
